import { Component } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService } from '@app/services';

@Component({
    selector: 'app-import-time-off-data-card',
    templateUrl: './import-time-off-data-card.template.html',
    styleUrls: ['./import-time-off-data-card.style.scss'],
})
export class ImportTimeOffDataCardComponent {
    constructor(private analyticService: AnalyticService) {}

    trackTimeOffRequestsDataImport(): void {
        this.analyticService.trackEvent(AnalyticEvents.ReportingDataImporterTimeOffRequests);
    }

    trackTimeOffBalancesDataImport(): void {
        this.analyticService.trackEvent(AnalyticEvents.ReportingDataImporterTimeOffBalances);
    }

    trackTimeOffAdjustmentsDataImport(): void {
        this.analyticService.trackEvent(AnalyticEvents.ReportingDataImporterTimeOffAdjustments);
    }
}
